import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Api from "../services/Api"

const AcceptInvitePage = () => {
    const api = Api.getInstance()
    const { code } = useParams(); // Extract invite code from URL
    const navigate = useNavigate(); // Hook to navigate programmatically
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const data = {
            code: code
        }
        api.post('client/accept_invite', data).then(response => {
            setLoading(false)
            if (response.json.status === "ok") {
                // TODO: Should we use a javascript window.location.href = / instead?
                // window.location.href = "/";
                navigate('/');
                // setInvited(true);
            } else if (response.json.error) {
                setError(response.json.error)
            } else {
                setError('Unknown error. Please contact support')
            }
        })
    }, [])

    if (loading) return <div>Loading...</div>;
    if (error.length > 0) return <div className="text-center mt-4">Error: {error}</div>;

    return <div>Invite accepted successfully!</div>; // This message will appear briefly before redirecting
};

export default AcceptInvitePage;